import React, { Component } from 'react';
import styled from 'styled-components';
import close from '../../images/instore/icons/close.svg';
import media from './MediaQueries';

const StyledModal = styled.div`
  z-index: 11;
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0; margin: auto;
  display: flex;
  flex-direction: column;
  background: white;
  width: 80%;
  height: 70%;
  border-radius: 6px;
  overflow: hidden;
  padding: 60px 40px 40px 40px;
  box-shadow: 0 0 30px 6px rgba(0,0,0,.3);
  transition: transform .5s cubic-bezier(.5,0,0,1.2), opacity .5s cubic-bezier(.5,0,0,1.2);
  transform: ${props => props.open ? 'scale:(1)' : 'scale(0)'};
  opacity: ${props => props.open ? '1' : '0'};
  ${media.phone`
    border-radius: 0;
    width: 100%;
    height: 100%;
  `}
  .close {
    cursor: pointer;
    width: 18px;
    height: 18px;
    position: absolute;
    background:url(${close});
    background-repeat: no-repeat;
    background-size: contain;
    top: 40px;
    right: 40px;
  }
  .saveSelection {
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0; right: 0;
    width: 100%; height: 60px;
    background: #0091FF;
    color: white;
    font-size: 16px;
    border: none;
    outline: none;
  }
`

class Modal extends Component {
  render = () => {
    return (
      <StyledModal open={this.props.open}>
        <div className="close" onClick={this.props.onClick}></div>
        {this.props.children}
      </StyledModal>
    )
  }
}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/instore/Modal.js